import { makeBasicQueryKeys, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { SanityClient } from '@sanity/client'

export const documentationQueryKeys = makeBasicQueryKeys<{ slug: string }>('documentation')

type DocumentationDoc = {
  name: string
  slug: string
  content: string
}

type DocumentationList = Pick<DocumentationDoc, 'name' | 'slug'>[]

const listDocumentation = (sanityClient: SanityClient) =>
  sanityClient.fetch<DocumentationList>(
    `*[_type == "doc"] {name, 'slug': slug.current} | order(name asc)`
  )

export const listDocumentationQueryOptions = (sanityClient: SanityClient) =>
  queryOptions({
    queryKey: documentationQueryKeys.list(),
    queryFn: () => listDocumentation(sanityClient),
  })

export const useListDocumentation = (sanityClient: SanityClient) =>
  useQuery(listDocumentationQueryOptions(sanityClient))

const getDocumentationDoc = (sanityClient: SanityClient, params: { slug: string }) =>
  sanityClient.fetch<DocumentationDoc>(
    `*[_type == "doc" && slug.current == $slug][0]{name, 'slug': slug.current, content}`,
    params
  )

export const getDocumentationDocQueryOptions = (
  sanityClient: SanityClient,
  params: { slug: string }
) => ({
  queryKey: documentationQueryKeys.detail(params),
  queryFn: () => getDocumentationDoc(sanityClient, params),
})

export const useGetDocumentationDoc = (sanityClient: SanityClient, params: { slug: string }) =>
  useQuery(getDocumentationDocQueryOptions(sanityClient, params))
